import * as angular from "angular"
import "../edition/edition"
import "front-end-web-commons"

export default angular.module("scriptModule", ["editionModule", "commonScriptModule"])